/**
 * Settings Page - Configurações do Sistema
 */

import { useState } from "react";
import { Layout } from "@/components/Layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useSession } from "@/state/session";
import { can } from "@/lib/rbac";
import { BusinessInfoTab } from "@/components/settings/BusinessInfoTab";
import { IntegrationsTab } from "@/components/settings/IntegrationsTab";
import { NotificationsTab } from "@/components/settings/NotificationsTab";
import { AppearanceTab } from "@/components/settings/AppearanceTab";
import { SecurityTab } from "@/components/settings/SecurityTab";
import { AboutTab } from "@/components/settings/AboutTab";

export default function Settings() {
  const { user } = useSession();
  const isAdmin = can(user?.role, "settings", "manage");
  const [activeTab, setActiveTab] = useState(isAdmin ? "business" : "appearance");

  return (
    <Layout>
      <div className="max-w-6xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-bold">⚙️ Configurações</h1>
          <p className="text-muted-foreground mt-1">
            Personalize o sistema do seu jeitinho
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-6 gap-2">
            {isAdmin && (
              <>
                <TabsTrigger value="business" className="text-xs md:text-sm">
                  💼 Negócio
                </TabsTrigger>
                <TabsTrigger value="integrations" className="text-xs md:text-sm">
                  📡 Integrações
                </TabsTrigger>
              </>
            )}
            <TabsTrigger value="notifications" className="text-xs md:text-sm">
              🔔 Notificações
            </TabsTrigger>
            <TabsTrigger value="appearance" className="text-xs md:text-sm">
              🎨 Aparência
            </TabsTrigger>
            <TabsTrigger value="security" className="text-xs md:text-sm">
              🔒 Segurança
            </TabsTrigger>
            <TabsTrigger value="about" className="text-xs md:text-sm">
              🧾 Sobre
            </TabsTrigger>
          </TabsList>

          {isAdmin && (
            <>
              <TabsContent value="business">
                <BusinessInfoTab />
              </TabsContent>

              <TabsContent value="integrations">
                <IntegrationsTab />
              </TabsContent>
            </>
          )}

          <TabsContent value="notifications">
            <NotificationsTab />
          </TabsContent>

          <TabsContent value="appearance">
            <AppearanceTab />
          </TabsContent>

          <TabsContent value="security">
            <SecurityTab />
          </TabsContent>

          <TabsContent value="about">
            <AboutTab />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
